

export const hermioneReviewerReviewHinge = {
  _id: 'hermioneReviewerReviewHingeId',
  email: 'hermione@email.com',
  profileReviewId: 'hermioneProfileReviewHingeId',
  reviewerProfileId: 'hermioneReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Hermione! This will really help me!',
  profileReviewedFirstName: 'Ron',
}

export const dumbledoreReviewerReviewBumble = {
  _id: 'dumbledoreReviewerReviewBumbleId',
  email: 'dumbledore@email.com',
  profileReviewId: 'dumbledoreProfileReviewBumbleId',
  reviewerProfileId: 'dumbledoreReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Dumbledore! This will really help me!',
  profileReviewedFirstName: 'Ron',
}

export const harryReviewerReviewTinder = {
  _id: 'harryReviewerReviewTinderId',
  email: 'harry@email.com',
  profileReviewId: 'harryProfileReviewTinderId',
  reviewerProfileId: 'harryReviewerProfileId',
  starRating: 5,
  reviewText: 'Thanks so much for the review Harry! This will really help me!',
  profileReviewedFirstName: 'Ron',
}